export const qk = {
  me: ["me"] as const,
  identity: {
    mine: ["identity", "mine"] as const,
  },
  orgs: {
    mine: ["orgs", "mine"] as const,
    detail: (orgId: string) => ["orgs", "detail", orgId] as const,
    members: (orgId: string) => ["orgs", "members", orgId] as const,
    kyc: (orgId: string) => ["orgs", "kyc", orgId] as const,
    activity: (orgId: string) => ["orgs", "activity", orgId] as const,
    insights: (orgId: string) => ["orgs", "insights", orgId] as const,
    planStatus: (orgId: string) => ["orgs", "plan-status", orgId] as const,
    planCatalog: (orgId: string) => ["orgs", "plan-catalog", orgId] as const,
    planPurchases: (orgId: string) =>
      ["orgs", "plan-purchases", orgId] as const,
    planPurchase: (orgId: string, orderCode: string) =>
      ["orgs", "plan-purchase", orgId, orderCode] as const,
  },
  postings: {
    mine: (cursor?: string) =>
      cursor
        ? (["postings", "mine", cursor] as const)
        : (["postings", "mine"] as const),
    byOrg: (orgId: string) => ["postings", "byOrg", orgId] as const,
    detail: (id: string) => ["postings", "detail", id] as const,
    boostPreview: (id: string) => ["postings", "boostPreview", id] as const,
    boostSummary: (id: string) => ["postings", "boostSummary", id] as const,
    editConstraints: (id: string) =>
      ["postings", "editConstraints", id] as const,
    feed: (q?: Record<string, unknown>) =>
      q ? (["postings", "feed", q] as const) : (["postings", "feed"] as const),
  },
  orgAddresses: {
    list: (orgId: string) => ["orgAddresses", "list", orgId] as const,
  },
  postingTemplates: {
    list: (orgId: string) => ["postingTemplates", "list", orgId] as const,
  },
  applications: {
    byPosting: (postingId: string) =>
      ["applications", "byPosting", postingId] as const,
    profile: (applicationId: string) =>
      ["applications", "profile", applicationId] as const,
    mine: ["applications", "mine"] as const,
    pending: ["applications", "pending"] as const,
    employer: (q?: Record<string, unknown>) =>
      q && Object.keys(q).length > 0
        ? (["applications", "employer", q] as const)
        : (["applications", "employer"] as const),
    employerCounts: (orgAddressId?: string) =>
      orgAddressId
        ? (["applications", "employerCounts", orgAddressId] as const)
        : (["applications", "employerCounts"] as const),
    creditLedger: ["applications", "creditLedger"] as const,
  },
  creditPurchases: {
    list: (orgId: string) => ["creditPurchases", "list", orgId] as const,
    pricing: ["creditPurchases", "pricing"] as const,
  },
  invites: {
    mine: ["invites", "mine"] as const,
    detail: (id: string) => ["invites", "detail", id] as const,
    byOrg: (orgId: string) => ["invites", "byOrg", orgId] as const,
    interviews: (q?: Record<string, unknown>) =>
      q && Object.keys(q).length > 0
        ? (["invites", "interviews", q] as const)
        : (["invites", "interviews"] as const),
  },
  slots: {
    byLocation: (orgId: string, locId: string) =>
      ["slots", orgId, locId] as const,
  },
  talent: {
    feed: (orgId: string, q?: Record<string, unknown>) =>
      q && Object.keys(q).length > 0
        ? (["talent", "feed", orgId, q] as const)
        : (["talent", "feed", orgId] as const),
    profile: (orgId: string, workerId: string) =>
      ["talent", "profile", orgId, workerId] as const,
  },
  notifications: {
    mine: ["notifications", "mine"] as const,
    all: ["notifications", "all"] as const,
  },
  public: {
    pricing: ["public", "pricing"] as const,
    postings: (q?: Record<string, unknown>) =>
      q && Object.keys(q).length > 0
        ? (["public", "postings", q] as const)
        : (["public", "postings"] as const),
  },
  ratings: {
    byUser: (userId: string) => ["ratings", "user", userId] as const,
    byOrg: (orgId: string) => ["ratings", "org", orgId] as const,
  },
  admin: {
    dashboard: ["admin", "dashboard"] as const,
    analytics: (kind: string, q?: Record<string, unknown>) =>
      q && Object.keys(q).length > 0
        ? (["admin", "analytics", kind, q] as const)
        : (["admin", "analytics", kind] as const),
    todo: ["admin", "todo"] as const,
    shadowOrgsWithApplicants: (q?: Record<string, unknown>) =>
      q && Object.keys(q).length > 0
        ? (["admin", "shadowOrgsWithApplicants", q] as const)
        : (["admin", "shadowOrgsWithApplicants"] as const),
    assignableShadowOrgs: (q?: Record<string, unknown>) =>
      q && Object.keys(q).length > 0
        ? (["admin", "assignableShadowOrgs", q] as const)
        : (["admin", "assignableShadowOrgs"] as const),
    users: (q?: Record<string, unknown>) =>
      q && Object.keys(q).length > 0
        ? (["admin", "users", q] as const)
        : (["admin", "users"] as const),
    userSessions: (id: string) => ["admin", "users", id, "sessions"] as const,
    workerKyc: ["admin", "workerKyc"] as const,
    workerKycDetail: (id: string) => ["admin", "workerKyc", id] as const,
    identity: ["admin", "identity"] as const,
    identityDetail: (id: string) => ["admin", "identity", id] as const,
    orgKyc: ["admin", "orgKyc"] as const,
    orgKycDetail: (id: string) => ["admin", "orgKyc", id] as const,
    orgs: (q?: Record<string, unknown>) =>
      q && Object.keys(q).length > 0
        ? (["admin", "orgs", q] as const)
        : (["admin", "orgs"] as const),
    postings: (q?: Record<string, unknown>) =>
      q
        ? (["admin", "postings", q] as const)
        : (["admin", "postings"] as const),
    posting: (id: string) => ["admin", "postings", id] as const,
    applicants: (postingId: string) =>
      ["admin", "applicants", postingId] as const,
    applicantProfile: (applicationId: string) =>
      ["admin", "applicants", "profile", applicationId] as const,
    invitations: (orgId: string) => ["admin", "invitations", orgId] as const,
    orgMembers: (orgId: string) => ["admin", "orgMembers", orgId] as const,
    orgAddresses: (orgId: string) => ["admin", "orgAddresses", orgId] as const,
    creditPurchases: (q?: Record<string, unknown>) =>
      q && Object.keys(q).length > 0
        ? (["admin", "creditPurchases", q] as const)
        : (["admin", "creditPurchases"] as const),
    creditPurchaseSummary: (q?: Record<string, unknown>) =>
      q && Object.keys(q).length > 0
        ? (["admin", "creditPurchaseSummary", q] as const)
        : (["admin", "creditPurchaseSummary"] as const),
    creditPurchase: (id: string) =>
      ["admin", "creditPurchases", "detail", id] as const,
    notificationTemplates: ["admin", "notificationTemplates"] as const,
    notificationTemplate: (type: string) =>
      ["admin", "notificationTemplates", type] as const,
    systemPostingTemplates: ["admin", "systemPostingTemplates"] as const,
    abuse: (q?: Record<string, unknown>) =>
      q ? (["admin", "abuse", q] as const) : (["admin", "abuse"] as const),
    claimInvitations: (q?: Record<string, unknown>) =>
      q
        ? (["admin", "claimInvitations", q] as const)
        : (["admin", "claimInvitations"] as const),
    activity: (q?: Record<string, unknown>) =>
      q
        ? (["admin", "activity", q] as const)
        : (["admin", "activity"] as const),
    orgInterviews: (orgId: string, q?: Record<string, unknown>) =>
      q && Object.keys(q).length > 0
        ? (["admin", "orgInterviews", orgId, q] as const)
        : (["admin", "orgInterviews", orgId] as const),
    invites: (q?: Record<string, unknown>) =>
      q && Object.keys(q).length > 0
        ? (["admin", "invites", q] as const)
        : (["admin", "invites"] as const),
    giftCodes: (q?: Record<string, unknown>) =>
      q && Object.keys(q).length > 0
        ? (["admin", "giftCodes", q] as const)
        : (["admin", "giftCodes"] as const),
  },
} as const;
